import { render } from "./DiagramPanel.vue?vue&type=template&id=8538a772&scoped=true"
import script from "./DiagramPanel.vue?vue&type=script&lang=ts"
export * from "./DiagramPanel.vue?vue&type=script&lang=ts"

import "./DiagramPanel.vue?vue&type=style&index=0&id=8538a772&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8538a772"

export default script